import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Login.css";
import { IoMdEye, IoMdEyeOff } from "react-icons/io";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Header from "../../components/layout/header";
import axios from "axios";
import { BASE_URL } from "../../constant";

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [isChecked, setIsChecked] = useState(false);
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    const formErrors = validateForm();
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      return;
    }
    try {
      const userType = "USER";
      const response = await axios.post(
        `${BASE_URL}/users/loginUser?emailId=${email}&password=${password}&userType=${userType}`
      );

      const { userId } = response.data;

      if (!userId) {
        toast.error(
          "User not found. Please check your credentials or sign up."
        );
        return;
      }

      // Save user ID in local storage
      localStorage.setItem("userId", userId);
      toast.success("Login successful!");

      // Redirect back to the previous page
      navigate(-1);
    } catch (error) {
      toast.error("Login failed. Please check your credentials.");
      console.error("Login error:", error);
    }
  };

  const validateForm = () => {
    const errors = {};
    if (!email.trim() || !/\S+@\S+\.\S+/.test(email)) {
      errors.email = "Please enter a valid email address.";
    }
    if (!password.trim() || password.length < 7) {
      errors.password = "Password must be at least 7 characters long.";
    }
    if (!isChecked) {
      errors.isChecked = "Please agree to continue.";
    }
    return errors;
  };

  return (
    <div className="signup-page">
      <Header />
      <div className="login-email-form-container">
        <form className="login-email-form" onSubmit={handleLogin}>
          <h2 className="login-email-title">Login with Email</h2>
          <div className="d-flex flex-col justify-content-center align-items-start">
            <label>
              Email <span style={{ color: "red" }}>*</span>
            </label>{" "}
            {errors.email && <p className="error-message">{errors.email}</p>}
            <input
              type="email"
              placeholder="Email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="login-email-input"
            />
          </div>{" "}
          <div style={{ position: "relative", cursor: "pointer" }}>
            <div className="d-flex flex-col justify-content-center align-items-start">
              <label>
                Password <span style={{ color: "red" }}>*</span>
              </label>{" "}
              {errors.password && (
                <p className="error-message">{errors.password}</p>
              )}
              <input
                type={isPasswordVisible ? "text" : "password"}
                placeholder=""
                name="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="login-email-input"
              />
            </div>
            <div
              style={{ position: "absolute", right: "3%", top: "45%" }}
              onClick={() => setIsPasswordVisible(!isPasswordVisible)}
            >
              {isPasswordVisible ? (
                <IoMdEye size={20} />
              ) : (
                <IoMdEyeOff size={20} />
              )}
            </div>
          </div>
          <div className="forgot-password-container">
            <Link to="/forgot-password" className="forgot-password-link">
              Forgot password?
            </Link>
          </div>
          <div>
            {errors.isChecked && (
              <p className="error-message">{errors.isChecked}</p>
            )}
            <input
              type="checkbox"
              checked={isChecked}
              style={{ cursor: "pointer", margin: "8px" }}
              onChange={(e) => setIsChecked(e.target.checked)}
            />
            By continuing, I agree to the{" "}
            <span>
              <Link to="/terms-of-use" className="login-highlight">
                Terms Of Use
              </Link>
            </span>{" "}
            and{" "}
            <span>
              <Link to="/privacy-policy" className="login-highlight">
                Privacy Policy
              </Link>
            </span>
          </div>
          <button className="login-email-button" type="submit">
            CONTINUE
          </button>
          <p className="login-help">
            Having trouble logging in?{" "}
            <span>
              <Link to="/contact" className="login-help-highlight">
                Get Help
              </Link>
            </span>
          </p>
          <p className="login-help">
            Do not have an account?{" "}
            <Link to="/signup" className="login-help-highlight">
              Signup
            </Link>
          </p>
        </form>
      </div>
    </div>
  );
};

export default Login;
